/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_PROVIDERIDTYPE_DATA = 'GET_PROVIDERIDTYPE_RESULT_DETAILS';
export const GET_PROVIDER_DETAILS = 'GET_PROVIDER_DETAILS';
export const GET_PROVIDER_DETAILS_DATA = 'GET_PROVIDER_DETAILS_DATA';
export const GET_CONTACT_DETAILS = 'GET_CONTACT_DETAILS';
export const GET_EXISTING_CONTACT_DETAILS = 'GET_EXISTING_CONTACT_DETAILS';
export const GET_CONTACT_DESCRIPTION_DETAILS =
  'GET_CONTACT_DESCRIPTION_DETAILS';
export const SEARCH_PROVIDER_DETAILS = 'SEARCH_PROVIDER_DETAILS';
export const UPDATE_CONTACT_DETAILS = 'UPDATE_CONTACT_DETAILS';
export const SET_ATTACHMENTS_DDD_VALUES = 'SET_ATTACHMENTS_DDD_VALUES';
export const SET_PROVIDER_TAB_DATA = 'SET_PROVIDER_TAB_DATA';
export const SEARCH_PROVIDER_REQUEST = 'SEARCH_PROVIDER_REQUEST';
